import React from 'react';
import styled from 'styled-components';

// Styled Components for the Hero Section
const HeroSection = styled.section`
  background-image: url('./images/cr.jpg');
  background-size: cover;
  background-position: center;
  color: red;
  text-align: center;
  padding: 100px 20px;
  height: 100vh; /* Ensures the hero section takes up the full height of the viewport */
  display: flex;
  justify-content: center;
  align-items: center;
  
  
  /* Mobile responsiveness */
  @media (max-width: 768px) {
    padding: 60px 10px;
  }
`;

const Overlay = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  padding: 40px;
  display: inline-block;
  border-radius: 10px;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3); /* Adding a subtle shadow for better text visibility */
  backdrop-filter: blur(10px); /* Optional: adds a blur effect to the background */
`;

const Button = styled.a`
  display: inline-block;
  border-radius: 5px;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: red;
  color: white;
  text-decoration: none;
  font-weight: bold;
  transition: box-shadow 0.3s ease-in-out, transform 0.3s;
  
  /* Focus and hover effects */
  &:hover, &:focus {
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.8),
                0 0 20px rgba(0, 123, 255, 0.6),
                0 0 30px rgba(0, 123, 255, 0.4);
    transform: scale(1.05); 
  }
  
  /* Accessibility improvements: focus state */
  &:focus {
    outline: 2px solid rgba(0, 123, 255, 0.6);
  }
`;

// Hero Component
const Hero = () => {
  return (
    <HeroSection id='home'>
      <Overlay>
        <h1>Welcome to Our Church</h1>
        <p>Matthew 28:19 (KJV): Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost.</p>
        <Button href="/about" aria-label="Learn more about our church">Learn More</Button>
      </Overlay>
    </HeroSection>
  );
};

export default Hero;
